<template>
    <form autocomplete="off"
        @submit.prevent="handleSubmit"
    >
        <input autocomplete="off" name="hidden" type="text" style="display:none;">
        <div
            class="form-group"
            :class="{'has-error': errors.has('password')}"
        >
            <label>
                Hasło
            </label>
            <input
                type="password"
                class="form-control"
                name="password"
                v-model="user.password"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('password')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('re_password')}"
        >
            <label>
                Powtórz hasło
            </label>
            <input
                type="password"
                class="form-control"
                name="re_password"
                v-model="user.re_password"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('re_password')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>

        <div class="hr-line-dashed"></div>
        <div class="form-group row">
            <div class="col-sm-4 col-sm-offset-2">
                <button class="btn btn-primary btn-sm" type="submit">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'usersPassswordForm',
    data() {
        return {
            title: 'Dodaj użytkownika',
            loading: false,
            user: {
                password: '',
                re_password: ''
            }
        }
    },
    created() {
        this.$emit( 'loading', false )
    },
    methods: {
        handleSubmit() {
            this.$validator.validateAll().then( result => {
                if ( result ) {
                    this.$emit( 'loading', true )
                    this.$http.put( `users/password/${ this.$route.params.id }`, this.user )
                        .then( () => {
                            this.$emit( 'loading', false )
                            this.$toastr.success( 'Hasło zostało zmienione' )
                            this.$router.push( { name: 'users' } )
                        } )
                        .catch( err => {
                            this.$toastr.error( this.convertErrorToPopupText( err.data ) )
                            this.$emit( 'loading', false )
                        } )
                }
            } )
        },
        convertErrorToPopupText( error ) {
            const text = []
            if ( error !== undefined && error !== '' ) {
                text.push( '<ul>' )
                for ( const [ key, value ] of Object.entries( error ) ) {
                    text.push( `<li> ${value.join( ' ' )} </li>` )
                }
                text.push( '</ul>' )
            }
            return text.join( '' )
        }
    }
}
</script>

